import {Router} from "@angular/router"
import {inject} from "@angular/core"
import {AuthService} from "@features/auth/auth.service"
import {map} from "rxjs"
import {APP_ROUTE_NAMES} from "@app/app.routes"

export const redirectAuthClientToProfileGuard = () => {
  const auth = inject(AuthService)
  const router = inject(Router)

  return auth.authenticated$.pipe(map(authenticated => authenticated ? router.createUrlTree([APP_ROUTE_NAMES.PROFILE]) : true))
}
